import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'
import './facetTracking.js';

Alpine.plugin(intersect)

window.Alpine = Alpine;
 
Alpine.start();

/**
 * Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  });
}